import { MacWindow } from './MacWindow';
import React from 'react';
import { X, Keyboard, Command, CornerDownLeft } from 'lucide-react';

interface KeyboardShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const KeyboardShortcutsModal: React.FC<KeyboardShortcutsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const shortcuts = [
    { key: 'Arrow Keys', desc: 'Nudge element position by 1pt' },
    { key: 'Shift + Arrow', desc: 'Fine nudge element position by 10pt' },
    { key: 'Delete / Backspace', desc: 'Delete currently selected element(s)' },
    { key: 'Ctrl + D / ⌘D', desc: 'Duplicate selected element(s)' },
    { key: 'Ctrl + C / ⌘C', desc: 'Copy selected element(s) to clipboard' },
    { key: 'Ctrl + V / ⌘V', desc: 'Paste copied element(s) onto canvas' },
    { key: 'Ctrl + G / ⌘G', desc: 'Group multiple selected elements' },
    { key: 'Ctrl + Shift + G', desc: 'Ungroup selected element group' },
    { key: 'Ctrl + Z / ⌘Z', desc: 'Undo last design action' },
    { key: 'Space + Drag', desc: 'Pan / Hand tool on canvas' },
    { key: 'Escape', desc: 'Cancel active tool or drawing mode' },
  ];

  return (
    <MacWindow isOpen={isOpen} onClose={onClose} title="Keyboard Shortcuts" maxWidth="max-w-lg">
      <div className="flex flex-col w-full overflow-hidden">
        
        {/* Header */}
        <div className="px-6 py-4 bg-zinc-950 border-b border-zinc-800 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-xl bg-blue-500/10 text-blue-400 border border-blue-500/20">
              <Keyboard className="w-5 h-5" />
            </div>
            <div>
              <h2 className="text-base font-bold text-white">Production Keyboard Shortcuts</h2>
              <p className="text-xs text-zinc-400">High-speed hotkeys for press operators & designers</p>
            </div>
          </div>
          
        </div>

        {/* Shortcuts List */}
        <div className="p-6 divide-y divide-zinc-800/60 max-h-[60vh] overflow-y-auto">
          {shortcuts.map((sc, index) => (
            <div key={index} className="py-2.5 flex items-center justify-between gap-4">
              <span className="text-xs text-zinc-300 font-medium">{sc.desc}</span>
              <kbd className="px-2.5 py-1 bg-zinc-950 text-zinc-200 border border-zinc-800 rounded font-mono text-[11px] font-semibold shrink-0 shadow-inner">
                {sc.key}
              </kbd>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-zinc-950 border-t border-zinc-800 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-xs font-semibold transition-colors cursor-pointer"
          >
            Got it
          </button>
        </div>

      </div>
    </MacWindow>
  );
};

